import { create } from "zustand";
import { PersistOptions, persist } from "zustand/middleware";
import { produce } from "immer";
import CryptoJS from 'crypto-js';
import { AttributeState, Attributes, initAttributes } from "./initialState";

export const useAttributesStore = create<AttributeState>() (
  persist(
    (set, get) => ({
      attributes: CryptoJS.AES.encrypt(JSON.stringify(initAttributes), process.env.NEXT_PUBLIC_HASH_CODE!).toString(),
      updateAttributes: (attributes: Attributes) => {
        set(
          produce((draft: AttributeState) => {
            const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(attributes), process.env.NEXT_PUBLIC_HASH_CODE!).toString();
            draft.attributes = encryptedUser;
          })
        )
      },
      getAttributes: () => {
        const state = get();

        if (state.attributes.constructor === ({}).constructor) {
          set(
            produce((draft: AttributeState) => {
              const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(state.attributes), process.env.NEXT_PUBLIC_HASH_CODE!).toString();
              draft.attributes = encryptedUser;
            })
          )

          return state.attributes;
        } else if (state.attributes.constructor === "text".constructor) {
          try {
            return JSON.parse(CryptoJS.AES.decrypt(state.attributes, process.env.NEXT_PUBLIC_HASH_CODE!).toString(CryptoJS.enc.Utf8));
          } catch (error) {
            return initAttributes;
          }
        } else {
          return initAttributes;
        }
      }
    }), {
      name: "attributes"
    } as PersistOptions<AttributeState>
  )
)
